import { v4 as uuidv4 } from "uuid";

export class BaseEntityClass {
  type: string;
  entity_version: number;
  entity_id: string;

  constructor() {
    this.entity_id = uuidv4();
  }

  isValid(): boolean {
    return true;
  }
}
